var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2562 11.0753C14.8015 10.052 15.0856 8.90985 15.0833 7.75033C15.0833 3.83824 11.9121 0.666992 7.99997 0.666992C4.08789 0.666992 0.916637 3.83824 0.916637 7.75033C0.913697 9.42129 1.50436 11.039 2.5833 12.3149L2.59164 12.3253L2.59914 12.3337H2.5833L6.78664 16.7962C6.94245 16.9616 7.13045 17.0933 7.33907 17.1834C7.54769 17.2735 7.77253 17.32 7.99976 17.32C8.227 17.32 8.45183 17.2735 8.66045 17.1834C8.86907 17.0933 9.05707 16.9616 9.21289 16.7962L13.4166 12.3337H13.4008L13.4075 12.3257L13.4083 12.3249C13.4383 12.2891 13.4682 12.253 13.4979 12.2166C13.787 11.8614 14.0409 11.4795 14.2562 11.0753ZM8.00205 10.4582C7.33901 10.4582 6.70313 10.1948 6.23429 9.72601C5.76545 9.25717 5.50205 8.62128 5.50205 7.95824C5.50205 7.2952 5.76545 6.65932 6.23429 6.19048C6.70313 5.72163 7.33901 5.45824 8.00205 5.45824C8.66509 5.45824 9.30098 5.72163 9.76982 6.19048C10.2387 6.65932 10.5021 7.2952 10.5021 7.95824C10.5021 8.62128 10.2387 9.25717 9.76982 9.72601C9.30098 10.1948 8.66509 10.4582 8.00205 10.4582Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPerson);
export default __webpack_public_path__ + "static/media/map-person.c189e9bdaef10aef7ac44d7f5e25fe85.svg";
export { ForwardRef as ReactComponent };